import React, { useState } from "react";
import { MainContainter, CloseTabIconContainer, InfoIconContainer, TabText } from "./AppointmentInfoTab.style";
import InfoIcon from "../../assets/allIcons/InfoTabIcons/InfoIcon";
import CloseTabIcon from "../../assets/allIcons/InfoTabIcons/CloseTabIcon";

const AppointmentInfoTab = ({
  text,
}) => {

  const [close, setClose] = useState(false);

  return (
    <MainContainter close={close}>
      <InfoIconContainer><InfoIcon /></InfoIconContainer>
      <TabText>
        {text}
      </TabText>
      <CloseTabIconContainer onClick={() => {setClose(true)}}><CloseTabIcon /></CloseTabIconContainer>
    </MainContainter>
  )
}

export default AppointmentInfoTab;
